import React, { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { Box, Button, Card, Divider, Paper, Typography } from "@mui/material";
import { Container } from "@mui/system";
import { Link } from "react-router-dom";
import {
  FilteredByCategories,
  SearchBar,
} from "../../Component/user-dashboard/find-job/SearchAndFilter";
import { Fade } from "react-awesome-reveal";
import { GetJobSearchResult } from "./find-job/GetJobSearchResult";
import { useFindJobRecommendApiQuery } from "../../services/apiSlice";
import Swal from "sweetalert2";
import Loading from "../Loading";

const defaultValues = {
  job_categories: "",
};
//
const FindJob = () => {
  // useFindJobByCategoryApiQuery, useFindJobByZipCodeApiQuery;

  const [zipData, setZipData] = useState("");
  const [categoryData, setCategoryData] = useState("");
  console.log({ zipData });

  return (
    <>
      <Container>
        <Fade cascade>
          <Box
            // component="form"
            // onSubmit={handleSubmit(onSubmit)}
            className="min-h-screen w-full"
            sx={{ mt: 5, ml: 4 }}
            style={{
              display: "flex",

              // padding: "20px",
              // margin: "4px 10px",
              flexDirection: "column",
            }}
          >
            <Card
              style={{
                display: "flex",
                gridRowGap: "20px",
                // padding: "20px",
                // margin: "4px 10px",
                flexDirection: "column",
              }}
              sx={[
                { mx: 3, px: 4 },
                (theme) => ({
                  [theme.breakpoints.down("321")]: {
                    width: "100%",
                    py: 3,
                    px: 1,
                    mx: 1,
                  },
                }),
              ]}
            >
              <Typography
                variant="h1"
                component="h2"
                className="md:text-3xl text-base uppercase font-extrabold text-center py-2 md:py-4 "
                sx={{ textAlign: "center" }}
              >
                Find Customers
              </Typography>

              <SearchBar
                setZipData={setZipData}
                zipData={zipData}
                // handleSubmits={handleSubmits}
              />
              <FilteredByCategories
                categoryData={categoryData}
                setCategoryData={setCategoryData}
              />
            </Card>
            <Divider />

            <Typography
              variant="h1"
              component="h2"
              className="text-3xl  font-extrabold text-center py-12 md:py-20 "
            >
              Recommended for you
            </Typography>
            <SearchResult />
            <Container>
              <Paper
                sx={[
                  {
                    maxWidth: "lg",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    ml: 10,
                    my: 15,
                  },
                  (theme) => ({
                    [theme.breakpoints.down("sm")]: {
                      py: 3,
                      mx: 3,
                      ml: 3,
                    },
                  }),
                ]}
              >
                <Typography
                  variant="p"
                  component="p"
                  className="md:text-md md:px-5  font-normal text-center py-8 md:py-8  "
                >
                  Upgrade today to enjoy the full benefits of TOP Neigbourhood
                  Pro's Premium Membership
                </Typography>
                <Link to={"/dashboard/sub-premium-plan"}>
                  <Button className="text-md  font-normal text-center my-3  text-white px-5 py-6 bg-green-600 rounded-full">
                    Find out more
                  </Button>
                </Link>
              </Paper>
            </Container>
          </Box>
        </Fade>
      </Container>
    </>
  );
};

const SearchResult = (props) => {
  const { data, error, isError, isSuccess, isFetching } =
    useFindJobRecommendApiQuery();

  console.log({ data });

  let AllResult;
  if (isFetching) {
    AllResult = <Loading />;
  } else if (isSuccess) {
    AllResult = data?.getAvailableJob;
  } else if (isError) {
    AllResult = Swal.fire({
      icon: "error",
      title: "Oops...",
      text: error?.data?.message,
    });
  }

  return (
    <div className="flex  md:ml-20 justify-center  flex-col w-full  ">
      {data?.getAvailableJob.length > 0 ? (
        <GetJobSearchResult AllResult={AllResult} />
      ) : (
        <p className="py-4 text-center font-bold text-xs sm:text-base md:text-xl mx-3">
          No result found available
        </p>
      )}
    </div>
  );
};

export default FindJob;
